export default class LogosMarqueeFix {
    static init() {
        if (!window.customElements || !window.customElements.get) return

        const origDefine = window.customElements.define
        window.customElements.define = function (name, ctor, options) {
            if (name === 'logos-marquee' && ctor && ctor.prototype) {
                LogosMarqueeFix._patch(ctor)
            }
            return origDefine.call(this, name, ctor, options)
        }

        const existing = window.customElements.get('logos-marquee')
        if (existing && existing.prototype) {
            LogosMarqueeFix._patch(existing)
        }
    }

    static _patch(Ctor) {
        if (Ctor.prototype.__logosMarqueeFixed) return
        Ctor.prototype.__logosMarqueeFixed = true

        const origInit = Ctor.prototype.init
        Ctor.prototype.init = function () {
            if (this.marqueeConf && !('pauseOnHover' in this.marqueeConf)) {
                this.marqueeConf.pauseOnHover = true
            }
            return origInit.call(this)
        }

        Ctor.prototype.buildMarquee = function () {
            if (this._marqueeInitDone) return
            this._marqueeInitDone = true

            const conf = Object.assign(
                {
                    allowCss3Support: true,
                    css3easing: 'linear',
                    easing: 'linear',
                    delayBeforeStart: 0,
                    direction: 'left',
                    duplicated: true,
                    duration: 5000,
                    speed: 0,
                    gap: 0,
                    pauseOnCycle: false,
                    pauseOnHover: false,
                    startVisible: true
                },
                this.marqueeConf || {}
            )

            const wrapper = this.querySelector('.wrapper')
            if (!wrapper) return

            const originalChildren = Array.from(wrapper.children)
            if (!originalChildren.length) return

            this.fillMarqueeElements && this.fillMarqueeElements()

            const gap = conf.gap || 0
            const isVertical = conf.direction === 'up' || conf.direction === 'down'

            wrapper.style.display = 'flex'
            wrapper.style.flexWrap = 'nowrap'
            wrapper.style.alignItems = 'center'
            if (isVertical) {
                wrapper.style.flexDirection = 'column'
            }
            wrapper.style.gap = `${gap}px`
            wrapper.style.willChange = 'transform'
            if (!isVertical) {
                wrapper.style.width = 'max-content'
            }

            wrapper.getBoundingClientRect()

            const totalSize = isVertical ? wrapper.scrollHeight : wrapper.scrollWidth
            const halfSize = totalSize / 2 || 1

            let distance, axis
            if (conf.direction === 'left') {
                distance = -halfSize
                axis = 'X'
            } else if (conf.direction === 'right') {
                distance = halfSize
                axis = 'X'
            } else if (conf.direction === 'up') {
                distance = -halfSize
                axis = 'Y'
            } else if (conf.direction === 'down') {
                distance = halfSize
                axis = 'Y'
            } else {
                distance = -halfSize
                axis = 'X'
            }

            const startTransform = 'translate3d(0,0,0)'
            const endTransform = axis === 'X' ? `translate3d(${distance}px,0,0)` : `translate3d(0,${distance}px,0)`

            wrapper.style.transform = startTransform

            let duration = conf.duration
            if (conf.speed > 0 && halfSize > 0) {
                duration = Math.round((halfSize / conf.speed) * 1000)
            }

            const startAnimation = () => {
                const anim = wrapper.animate([{ transform: startTransform }, { transform: endTransform }], {
                    duration,
                    iterations: Infinity,
                    easing: conf.css3easing || conf.easing || 'linear'
                })

                this._marqueeAnim = anim

                const pauseFn = () => anim.pause()
                const resumeFn = () => anim.play()

                if (conf.pauseOnHover) {
                    this.addEventListener('mouseenter', pauseFn)
                    this.addEventListener('mouseleave', resumeFn)
                }

                if (conf.pauseOnCycle) {
                    this.addEventListener('click', () => {
                        if (anim.playState === 'running') {
                            anim.pause()
                        } else {
                            anim.play()
                        }
                    })
                }
            }

            if (conf.delayBeforeStart > 0) {
                setTimeout(startAnimation, conf.delayBeforeStart)
            } else {
                startAnimation()
            }

            this.marqueeInst = {
                pause: () => this._marqueeAnim && this._marqueeAnim.pause(),
                resume: () => this._marqueeAnim && this._marqueeAnim.play()
            }
        }
    }
}
